import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-completed',
  templateUrl: './completed.component.html',
  standalone: false,
})
export class CompletedComponent implements OnInit {
  ngOnInit(): void {
    sessionStorage.removeItem('activeQuestionnaireInstanceGuid');
    sessionStorage.removeItem('activeQuestionnaireRespondentName');

    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  }
}
